export default function DualRangeSlider({ min, max, step = 1, valueMin, valueMax, onChangeMin, onChangeMax, format = v => v }) {
  const pct    = v => ((v - min) / (max - min)) * 100;
  const minPct = pct(valueMin);
  const maxPct = pct(valueMax);
  const minZ = minPct >= 95 ? 5 : 3;
  const maxZ = minPct >= 95 ? 3 : 5;

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, fontWeight: 700, color: "#92400e", marginBottom: 6 }}>
        <span style={{ background: "#fff9e6", padding: "1px 8px", borderRadius: 999,border: "1px solid #fbbf24" }}>{format(valueMin)}</span>
        <span style={{ background: "#fff9e6", padding: "1px 8px", borderRadius: 999,border: "1px solid #fbbf24" }}>
          {format(valueMax)}{valueMax >= max ? "+" : ""}
        </span>
      </div>
      <div style={{ position: "relative", height: 28, display: "flex", alignItems: "center" }}>
        {/* Track background */}
        <div style={{
          position: "absolute", width: "100%", height: 6,
          background: "#fde68a", borderRadius: 999, border: "1px solid #fbbf24",
        }} />
        {/* Active range fill */}
        <div style={{
          position: "absolute",
          left:  `${minPct}%`,
          right: `${100 - maxPct}%`,
          height: 6,
          background: "linear-gradient(90deg, #f97316, #dc2626)",
          borderRadius: 999,
        }} />
        {/* Min thumb */}
        <input
          type="range" min={min} max={max} step={step} value={valueMin}
          onChange={e => {
            const val = Number(e.target.value);
            if (val <= valueMax) onChangeMin(val);
          }}
          style={{ ...thumbBase, zIndex: minZ }}
        />
        {/* Max thumb */}
        <input
          type="range" min={min} max={max} step={step} value={valueMax}
          onChange={e => {
            const val = Number(e.target.value);
            if (val >= valueMin) onChangeMax(val);
          }}
          style={{ ...thumbBase, zIndex: maxZ }}
        />
      </div>
    </div>
  );
}

const thumbBase = {
  position: "absolute", width: "100%", height: 6,
  appearance: "none", WebkitAppearance: "none",
  background: "transparent", cursor: "pointer", outline: "none",
  pointerEvents: "none", // let clicks fall through to whichever thumb has higher z
};